import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkUpdateNotificationStatusByFilterRequest = {};
var _bulkUpdateNotificationStatusByFilterResponse = {};
var _countUnseenNotificationsForUserRequest = {};
var _countUnseenNotificationsForUserResponse = {};
var _countViewerFeedNotificationsRequest = {};
var _countViewerFeedNotificationsResponse = {};
var _deleteViewerFeedNotificationRequest = {};
var _deleteViewerFeedNotificationResponse = {};
var _membersViewerFeedNotification = {
    sentDate: 'google.protobuf.Timestamp',
};
var _queryViewerFeedNotificationsRequest = {};
var _queryViewerFeedNotificationsResponse = {
    viewerFeedNotifications: '_membersViewerFeedNotification',
};
var _totalCountForMultipleMembersAcrossMultipleSitesRequest = {};
var _totalCountForMultipleMembersAcrossMultipleSitesResponse = {};
function resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members-feed-viewer',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of ViewerFeedNotifications */
export function queryViewerFeedNotifications(payload) {
    var _a = serializer(_queryViewerFeedNotificationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryViewerFeedNotificationsResponse, { _membersViewerFeedNotification: _membersViewerFeedNotification }).fromJSON;
    function __queryViewerFeedNotifications(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.members_feed.v1.members_viewer_feed_notification',
            method: 'POST',
            methodFqn: 'wix.notifications.members_feed_viewer.v1.MembersViewerFeedNotificationsService.QueryViewerFeedNotifications',
            url: resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl({
                protoPath: '/v1/members-viewer-feed-notifications/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryViewerFeedNotifications.fromReq = fromReq;
    __queryViewerFeedNotifications.__isAmbassador = true;
    return __queryViewerFeedNotifications;
}
/** Deletes a ViewerFeedNotification. */
export function deleteViewerFeedNotification(payload) {
    var _a = serializer(_deleteViewerFeedNotificationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteViewerFeedNotificationResponse, {}).fromJSON;
    function __deleteViewerFeedNotification(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.members_feed.v1.members_viewer_feed_notification',
            method: 'DELETE',
            methodFqn: 'wix.notifications.members_feed_viewer.v1.MembersViewerFeedNotificationsService.DeleteViewerFeedNotification',
            url: resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl({
                protoPath: '/v1/members-viewer-feed-notifications/{viewerFeedNotificationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteViewerFeedNotification.fromReq = fromReq;
    __deleteViewerFeedNotification.__isAmbassador = true;
    return __deleteViewerFeedNotification;
}
/**
 * BulkUpdateStatusByFilter
 * same possible filter as query method
 */
export function bulkUpdateNotificationStatusByFilter(payload) {
    var _a = serializer(_bulkUpdateNotificationStatusByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateNotificationStatusByFilterResponse, {}).fromJSON;
    function __bulkUpdateNotificationStatusByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.members_feed.v1.members_viewer_feed_notification',
            method: 'POST',
            methodFqn: 'wix.notifications.members_feed_viewer.v1.MembersViewerFeedNotificationsService.BulkUpdateNotificationStatusByFilter',
            url: resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl({
                protoPath: '/v1/bulk/members-viewer-feed-notifications/update-status-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateNotificationStatusByFilter.fromReq = fromReq;
    __bulkUpdateNotificationStatusByFilter.__isAmbassador = true;
    return __bulkUpdateNotificationStatusByFilter;
}
/**
 * CountViewerFeedNotifications
 * same possible filter as query method
 */
export function countViewerFeedNotifications(payload) {
    var _a = serializer(_countViewerFeedNotificationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countViewerFeedNotificationsResponse, {}).fromJSON;
    function __countViewerFeedNotifications(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.members_feed.v1.members_viewer_feed_notification',
            method: 'POST',
            methodFqn: 'wix.notifications.members_feed_viewer.v1.MembersViewerFeedNotificationsService.CountViewerFeedNotifications',
            url: resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl({
                protoPath: '/v1/members-viewer-feed-notifications/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countViewerFeedNotifications.fromReq = fromReq;
    __countViewerFeedNotifications.__isAmbassador = true;
    return __countViewerFeedNotifications;
}
/**
 * CountUnseenNotificationsForUser
 * returns the count of mobile unseen MembersViewerFeedNotification for the user's members in the provided sites, user is taken from context.
 */
export function countUnseenNotificationsForUser(payload) {
    var _a = serializer(_countUnseenNotificationsForUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countUnseenNotificationsForUserResponse, {}).fromJSON;
    function __countUnseenNotificationsForUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.members_feed.v1.members_viewer_feed_notification',
            method: 'POST',
            methodFqn: 'wix.notifications.members_feed_viewer.v1.MembersViewerFeedNotificationsService.CountUnseenNotificationsForUser',
            url: resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl({
                protoPath: '/v1/members-viewer-feed-notifications/count-unseen-notification-for-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countUnseenNotificationsForUser.fromReq = fromReq;
    __countUnseenNotificationsForUser.__isAmbassador = true;
    return __countUnseenNotificationsForUser;
}
/**
 * TotalCountForMultipleSitesAndMembers
 * must be signed with relevant app
 */
export function totalCountForMultipleMembersAcrossMultipleSites(payload) {
    var _a = serializer(_totalCountForMultipleMembersAcrossMultipleSitesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_totalCountForMultipleMembersAcrossMultipleSitesResponse, {}).fromJSON;
    function __totalCountForMultipleMembersAcrossMultipleSites(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.notifications.members_feed.v1.members_viewer_feed_notification',
            method: 'POST',
            methodFqn: 'wix.notifications.members_feed_viewer.v1.MembersViewerFeedNotificationsService.TotalCountForMultipleMembersAcrossMultipleSites',
            url: resolveWixNotificationsMembersFeedViewerV1MembersViewerFeedNotificationsServiceUrl({
                protoPath: '/v1/members-viewer-feed-notifications/total-count-for-multiple-members-across-multiple-sites',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __totalCountForMultipleMembersAcrossMultipleSites.fromReq = fromReq;
    __totalCountForMultipleMembersAcrossMultipleSites.__isAmbassador = true;
    return __totalCountForMultipleMembersAcrossMultipleSites;
}
//# sourceMappingURL=http.impl.js.map